// Year Ahead 2027 Road Map: the one source for its bundles and prices, shared by the order page
// (/year-ahead-2027) and the Shop tab (/pricing?section=year-ahead), so both always sell the same thing.
// The Stripe webhook checks paid amounts against the same numbers (lambda/ivy-preorder-webhook.js
// YA_PRICE_EUR_CENTS: 2999 / 7198 / 12596 / 17994).
export const YA_UNIT_CENTS = 2999;
// until this day (buyer's local date) the Road Map is free with a 2027 Extended Forecast video order
export const YA_OFFER_LAST_DAY = '2026-10-31';
export const YA_BUNDLES = [
  { id: 'one', count: 1, discount: 0, label: 'One sign' },
  { id: 'three', count: 3, discount: 20, label: 'Three signs' },
  { id: 'six', count: 6, discount: 30, label: 'Six signs' },
  { id: 'twelve', count: 12, discount: 50, label: 'All 12 signs' },
];
export const yaFullCents = (b) => YA_UNIT_CENTS * b.count;
export const yaPriceCents = (b) => Math.round((yaFullCents(b) * (100 - b.discount)) / 100);
export const yaEur = (cents) => `€${(cents / 100).toFixed(2)}`;
